// extracted by mini-css-extract-plugin
export var linkText = "_nn-0";